/**
 * MSAL Configuration
 * Based on: https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-react/docs/getting-started.md
 */

import { Configuration } from "@azure/msal-browser";

/**
 * Get MSAL configuration from environment variables
 */
function getMsalConfig(): Configuration {
  const clientId = window._env_?.MICROSOFT_ENTRA_CLIENT_ID || "";

  const authority = `https://login.microsoftonline.com/common`;
  const redirectUri = window.location.origin;
  const postLogoutRedirectUri = window.location.origin;

  return {
    auth: {
      clientId,
      authority,
      redirectUri,
      postLogoutRedirectUri,
      navigateToLoginRequestUrl: false,
    },
    cache: {
      cacheLocation: "localStorage",
      storeAuthStateInCookie: true,
      claimsBasedCachingEnabled: true,
    },
    system: {
      loggerOptions: {
        loggerCallback: (level, message, containsPii) => {
          if (containsPii) return;
          console.warn(`[MSAL-${level}]:`, message);
        },
        piiLoggingEnabled: false,
      },
    },
  };
}

export const msalConfig: Configuration = getMsalConfig();

/**
 * Scopes for API access
 */
export const loginRequest = {
  scopes: ["openid", "profile", "email"],
};

/**
 * Scopes for Graph API access
 */
export const graphRequest = {
  scopes: ["https://graph.microsoft.com/User.Read"],
};

export default msalConfig;
